import { CustomEventNames, EventTypes, IMParticleCtx } from 'state/mParticle';
import { ClickEventComponentNames } from 'state/mParticle/constants';

export const logCartContinue = (mParticle: IMParticleCtx) => {
  mParticle.logRBIEvent({
    name: CustomEventNames.CLICK_EVENT,
    type: EventTypes.Navigation,
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      text: 'Continue in Cart',
    },
  });
};
export const logCartPlaceOrder = (mParticle: IMParticleCtx) => {
  mParticle.logRBIEvent({
    name: CustomEventNames.CLICK_EVENT,
    type: EventTypes.Navigation,
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      text: 'Place Secure Order',
    },
  });
};
export const logCartContinueOrder = (mParticle: IMParticleCtx) => {
  mParticle.logRBIEvent({
    name: CustomEventNames.CLICK_EVENT,
    type: EventTypes.Navigation,
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      text: 'Continue',
    },
  });
};
